import { translationsContent } from "../../../localization/translations";
import { useLanguage } from "../../../store/lang.context";
import { translate } from "../../../utils/translate";
import Button from "../../ui/button/SimpleButton";
import DynamicModal from "../../ui/modal/DynamicModal";
import classes from "./popup.module.scss";

interface Props {
  onClose: () => void;
}

const EmailErrorPopup = ({ onClose }: Props) => {
  const { language } = useLanguage();

  return (
    <DynamicModal onClose={onClose}>
      <div className={classes.container}>
        <h2>{translate(translationsContent, "socialLoginError", language)}</h2>
        <div className={classes.button}>
          <Button label="OK" onClick={onClose} />
        </div>
      </div>
    </DynamicModal>
  );
};

export default EmailErrorPopup;
